export default __webpack_public_path__ + "static/media/superhostroom-join-modal.0b57b336.svg";